import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Page from '../../../components/Page';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import backgroundImg from '../../../assets/login-background.svg';

const useStyles = makeStyles(theme => ({
  background: {
    padding: '5rem 1rem',
    width: '100%',
    minHeight: '56rem',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top',
    backgroundSize: 'contain',
    backgroundImage: `url(${backgroundImg})`,
    [theme.breakpoints.down('sm')]: {
      minHeight: '30rem',
      backgroundImage: 'none',
      padding: '1rem',
    },
  },
}));

const FlowContainer = ({children}) => {
  const classes = useStyles();
  return (
    <Page title={'Clickability'}>
      <div className={classes.background}>
        <Container maxWidth="lg" fixed disableGutters={true}>
          <Grid container spacing={0}>
            <Grid item sm={12}>
              {children}
            </Grid>
          </Grid>
        </Container>
      </div>
    </Page>
  );
};

FlowContainer.propTypes = {
  children: PropTypes.object.isRequired,
};

export default FlowContainer;
